// A `?next=` value round-trips through a URL, so it is attacker-controlled input even though it
// only ever comes from our own links. Accept it ONLY when it is a same-site, in-app path: starts
// with a single '/' (never '//' — browsers treat a scheme-relative `//evil.com` as a different
// host). A value carrying a scheme (`https://evil.com`, `javascript:alert(1)`) never starts with a
// single '/' either, so the same two checks cover it. Anything else falls back to '/dashboard',
// same as before `next` existed.
export function safeNextPath(raw: string | null | undefined): string {
  if (!raw) return '/dashboard'
  if (!raw.startsWith('/') || raw.startsWith('//')) return '/dashboard'
  return raw
}
